import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHarborComponent } from './simple-icons-harbor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHarborComponent ],
    exports:      [ SimpleIconsHarborComponent ],
    bootstrap:    []
})
export class SimpleIconsHarborModule {}
